// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3VVw1","alert":"SettungsInbox_alert__E2YhE"};